import React, { useEffect, useRef, useState } from "react";

// Live preview iframe that reloads when "stamp" changes
const LivePreview = ({ src, stamp }) => {
  const iframeRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    if (iframeRef.current) {
      // Force reload by resetting src (or with ?t query param)
      iframeRef.current.src = `${src}${src.includes("?") ? "&" : "?"}t=${stamp}`;
    }
  }, [stamp, src]);

  return (
    <div className="relative w-full h-full bg-white rounded-xl overflow-hidden shadow-lg border border-[var(--ri-border)]">
      {loading && (
        <div className="absolute inset-0 bg-[var(--ri-cream)] flex items-center justify-center z-10 pointer-events-none animate-pulse">
          <div className="text-[11px] text-[var(--ri-muted)] uppercase tracking-widest">Loading preview…</div>
        </div>
      )}
      <iframe
        ref={iframeRef}
        title="Live preview"
        className="w-full h-full border-0"
        onLoad={() => setLoading(false)}
        // scale wrapper handled by parent via style transform
      />
    </div>
  );
};

export default LivePreview;
